"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function removeChildren(values, children, valueKey) {
  var childrenValues = (0, _lodash.map)(children, function (c) {
    return c[valueKey];
  });
  return (0, _lodash.filter)(values, function (v) {
    return !(0, _lodash.includes)(childrenValues, v[valueKey]);
  });
}
var _default = exports["default"] = removeChildren;